module.exports = __webpack_public_path__ + "img/civil-engineering.ded0a3aa.jpg";